// extracted by mini-css-extract-plugin
export default {"bookShelfOuterContainer":"BookShelfDesktop_bookShelfOuterContainer__tFMFA","emptyShelf":"BookShelfDesktop_emptyShelf__fkrPr"};